import React from 'react';
import '../less/main.less';
import minus_icon from '../img/minus_icon.svg';
import plus_icon from '../img/plus_icon.svg';
import chevron_up from '../img/chevron_up.svg';
import chevron_down from '../img/chevron_down.svg';
import { ReactSVG } from 'react-svg';
import DOMPurify from 'utils/sanitize';

export default function template() {
  const { title, children, page, id, chevron_icon } = this.props;

  return (
    <>
      <div className={`dropdown-new${this.state.active ? ' active' : ''}`}>
        <div className="dropdown-new__header header-dropdown-new">
          <div className="container">
            <div className="header-dropdown-new__row" onClick={this.toggleActive} onKeyDown={(e) => e.key === 'Enter' && this.toggleActive} tabIndex="0" id={`${page ? page : ''} ${id ? id : ''} dropdown-new`}>
              <h3 className="header-dropdown-new__title" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(title))}}/>
              {chevron_icon ? (
                this.state.active ? (
                  <ReactSVG src={chevron_up} className="header-dropdown-new__arrow" alt="" />
                ) : (
                  <ReactSVG src={chevron_down} className="header-dropdown-new__arrow" alt="" />
                )
              ) : (
                this.state.active ? (
                  <ReactSVG src={minus_icon} className="header-dropdown-new__arrow"/>
                ) : (
                  <ReactSVG src={plus_icon} className="header-dropdown-new__arrow"/>
                )
              )}
            </div>
          </div>
        </div>
        <div className="dropdown-new__content">{children}</div>
      </div>
    </>
  );
}
